import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const DRIVERS_SEARCH_SUCCESS = 'DRIVERS_SEARCH_SUCCESS'
export const DRIVERS_LOAD_SUCCESS = 'DRIVERS_LOAD_SUCCESS'
export const DRIVERS_LOAD_ACTIVE_SUCCESS = 'DRIVERS_LOAD_ACTIVE_SUCCESS'
export const DRIVERS_IMPORT_SUCCESS = 'DRIVERS_IMPORT_SUCCESS'
export const DRIVERS_LOAD_START = 'DRIVERS_LOAD_START'
export const DRIVERS_LOAD_ERROR = 'DRIVERS_LOAD_ERROR'
export const DRIVERS_IMPORT_ERROR = 'DRIVERS_IMPORT_ERROR'
export const DRIVER_CREATE_SUCCESS = 'DRIVER_CREATE_SUCCESS'
export const DRIVER_LOAD_SUCCESS = 'DRIVER_LOAD_SUCCESS'
export const DRIVER_UPDATE_SUCESS = 'DRIVER_UPDATE_SUCESS'
export const DRIVER_DELETE_SUCCESS = 'DRIVER_DELETE_SUCCESS'
export const DRIVERS_LOAD_TODAY_ATTENDANCE_SUCCESS = 'DRIVERS_LOAD_TODAY_ATTENDANCE_SUCCESS'

export const CLEAR_DRIVERS = 'CLEAR_DRIVERS'
export const CLEAR_FOUND_DRIVERS = 'CLEAR_FOUND_DRIVERS'
export const CLEAR_DRIVER = 'CLEAR_DRIVER'

export const loadDrivers = (query) => ({ getState, fetch }) => ({
  type: 'DRIVERS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'drivers',
    getState,
    query,
  }),
})

export const importDrivers = (body) => ({ getState, fetch }) => ({
  type: 'DRIVERS_IMPORT',
  payload: apiPost({
    fetch,
    endpoint: 'drivers/import',
    getState,
    body,
  }),
})

export const searchDrivers = (query) => ({ getState, fetch }) => ({
  type: 'DRIVERS_SEARCH',
  payload: apiGet({
    fetch,
    endpoint: 'drivers/search',
    getState,
    query,
  }),
})

export const loadTodayAttendance = () => ({ getState, fetch }) => ({
  type: 'DRIVERS_LOAD_TODAY_ATTENDANCE',
  payload: apiGet({
    fetch,
    endpoint: 'drivers/today-attendance',
    getState,
  }),
})

export const loadDriver = (id) => ({ getState, fetch }) => ({
  type: 'DRIVER_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `drivers/${id}`,
    getState,
  }),
})

export const createDriver = (body) => ({ getState, fetch }) => ({
  type: 'DRIVER_CREATE',
  payload: apiPost({
    fetch,
    endpoint: 'drivers',
    getState,
    body,
  }),
})

export const updateDriver = (body) => ({ getState, fetch }) => ({
  type: 'DRIVER_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `drivers/${body._id}`,
    getState,
    body,
  }),
})

export const deleteDriver = (id) => ({ getState, fetch }) => ({
  type: 'DRIVER_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `drivers/${id}`,
    getState,
  }),
})

export const clearDrivers = () => ({
  type: 'CLEAR_DRIVERS',
  payload: {},
})

export const clearFoundDrivers = () => ({
  type: 'CLEAR_DRIVERS',
  payload: {},
})

export const clearDriver = () => ({
  type: 'CLEAR_DRIVER',
  payload: {},
})

export const getDriversCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_DRIVERS_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'drivers/csv',
    getState,
    query,
  }),
})



// WEBPACK FOOTER //
// ./src/common/drivers/actions.js